import styled from 'styled-components';

export const FormError = styled.div`
    display: block;
    font-size: 18px;
    font-weight: 500;
    margin: 5px 0 0;
    color: ${({ theme }) => theme.colors.danger};
`;
